module.exports = "/_next/static/images/a7a1947af6d9c45950d52e7bef807829-rewards-app-md@1x.png.webp";